<mat-card
    class="trinta-card error-card mb-25 bg-white border-none d-block text-center"
>
    <mat-card-content>
        <img src="images/error.png" alt="imagen-de-error">
        <h3>
            <span class="text-primary">¡OOPS!</span> Página No Encontrada
        </h3>
        <p class="text-black fs-15">
            ¡Pero no te preocupes! Nuestro equipo está buscando en todos lados mientras esperas seguro.
        </p>
        <a routerLink="/" mat-button>
            Volver al Inicio
            <i class="ri-send-plane-fill"></i>
        </a>
    </mat-card-content>
</mat-card>